<template>
  <footer class="bg-gray-800 py-6">
    <div class="container mx-auto text-center">
      <p class="text-sm text-gray-300">
        Tallinn, Estonia | &copy; USMANHEART OÜ 2022 - Now | All rights reserved.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterView",
};
</script>
